// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import rdata from './data.json'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function ToothChartData(props) {
  let data = rdata.value

  return (
    <DataProvider
      context="generate_letters"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}